import { ClientConfigurationBackend, ClientConfigurationEntry, ClientConfigurationForm } from '../Types/Types'

export const mapToServer = (data: ClientConfigurationForm): ClientConfigurationBackend => ({
    Description: data.details.description,
    CmeID: data.scope.cmeID,
    Policies: data.policy.policies.reduce(
        (
            accum: Record<string, string | number | boolean | string[] | Record<string, string>>,
            next: ClientConfigurationEntry
        ): Record<string, string | number | boolean | string[] | Record<string, string>> => ({
            ...accum,
            [next.item]: next.value
        }),
        {}
    ),
    Settings: data.settings.settings.reduce(
        (
            accum: Record<string, string | number | boolean | string[] | Record<string, string>>,
            next: ClientConfigurationEntry
        ): Record<string, string | number | boolean | string[] | Record<string, string>> => ({
            ...accum,
            [next.item]: next.value
        }),
        {}
    )
})
